/* 列傳選單點一章時的「圖解」：交戰雙方、前情、結果與影響（只寫正史；裴注要標出處，演義不放）
 * 鍵是列傳選單上的章節 id（分幕的章寫第一幕）。格式見 src/campaign/bg/index.ts。 */
// @ts-nocheck
export default {
  'xiahouyuan-1': {
    sides: [
      { f: 'wei', n: '曹操', l: '夏侯淵（督軍校尉）', w: 1 },
      { f: 'ys', n: '袁紹', l: '官渡敗後的袁軍' },
    ],
    before: '建安五年，曹操和袁紹在官渡相持，夏侯淵代理督軍校尉。袁紹戰敗後，曹軍自己的存糧也不多了，曹操讓夏侯淵督運兗、豫、徐三州的軍糧。',
    after: '夏侯淵讓糧車一批接一批送到前線，軍隊重新振作起來。',
    src: '《三國志·魏書·夏侯淵傳》',
  },
  'xiahouyuan-2': {
    sides: [
      { f: 'wei', n: '曹操', l: '夏侯淵、于禁', w: 1 },
      { f: 'han', n: '昌豨', l: '昌豨與東海諸屯' },
    ],
    before: '東海的昌豨反覆叛降。早先張遼和夏侯淵在東海圍過他，張遼上山說降（〈張遼傳〉）。昌豨後來又反，曹操派于禁去打，打不下來，再派夏侯淵和于禁合力。',
    after: '夏侯淵降服昌豨十餘座屯。昌豨跑去向舊識于禁投降，于禁說「圍而後降者不赦」，含淚斬了他。夏侯淵回來後拜典軍校尉，軍中傳說他「三日五百，六日一千」（裴注引《魏書》）。',
    src: '《三國志·魏書·夏侯淵傳》、〈于禁傳〉、〈張遼傳〉；裴注引《魏書》',
  },
  'xiahouyuan-3': {
    sides: [
      { f: 'wei', n: '夏侯淵', l: '夏侯淵、張郃（救姜敘等）', w: 1 },
      { f: 'xl', n: '馬超', l: '馬超與氐羌兵（從漢中借兵回來）' },
    ],
    before: '建安十九年，趙衢、尹奉等人密謀討伐馬超，姜敘在鹵城起兵響應，馬超的妻兒被殺，他逃到漢中投奔張魯，又帶兵回來包圍祁山。姜敘等人急忙求救，諸將想先請示遠在鄴城的曹操。',
    after: '夏侯淵說「公在鄴，反覆四千里」，等回覆就來不及了，立刻出兵。張郃到渭水邊，馬超沒交戰就退走；夏侯淵趕到時，各縣都已歸降。祁山被圍三十天才解（裴注引皇甫謐《列女傳》）。',
    src: '《三國志·魏書·夏侯淵傳》；裴注引皇甫謐《列女傳》',
  },
  'xiahouyuan-4': {
    sides: [
      { f: 'wei', n: '夏侯淵', l: '夏侯淵（輕兵步騎）', w: 1 },
      { f: 'xl', n: '韓遂', l: '韓遂與長離諸羌' },
      { f: 'han', n: '興國氐', l: '氐王千萬' },
    ],
    before: '解了祁山之圍，夏侯淵追韓遂到略陽。諸將有人想攻韓遂，有人想攻興國的氐人。夏侯淵認為韓遂兵精、興國城固，都不能很快拿下，改去燒長離諸羌的屯，因為韓遂軍裡很多是長離的羌人。',
    after: '羌兵果然各自回去救家，韓遂來救長離，被夏侯淵擂鼓直接衝垮，連旌旗都丟了。夏侯淵接著圍興國，氐王千萬逃去投靠馬超，其餘的人投降。韓遂逃往西平（《武帝紀》），次年被西平、金城諸將麴演、蔣石等人斬首送給曹操。',
    src: '《三國志·魏書·夏侯淵傳》、〈武帝紀〉',
  },
  'xiahouyuan-5': {
    sides: [
      { f: 'wei', n: '夏侯淵', l: '夏侯淵、張郃', w: 1 },
      { f: 'han', n: '宋建', l: '河首平漢王宋建' },
    ],
    before: '隴西的宋建趁涼州大亂，在枹罕自稱河首平漢王，改年號、設百官，前後三十多年。平定興國後，曹操派夏侯淵帶諸將去討伐。',
    after: '夏侯淵圍枹罕一個多月攻破，斬宋建和他設的丞相；又派張郃渡河進小湟中，河西諸羌全部投降，隴右平定。曹操下令稱讚他「虎步關右，所向無前」。五年後，夏侯淵在定軍山戰死。',
    src: '《三國志·魏書·夏侯淵傳》、〈武帝紀〉',
  },
};
